import HomeSvg from "@/src/svg/sidebar/HomeSvg";
import TaskSvg from "@/src/svg/sidebar/TaskSvg";
import ApplicationsSvg from "@/src/svg/sidebar/ApplicationsSvg";
import AdmissionsSvg from "@/src/svg/sidebar/AdmissionsSvg";
import AgentsSvg from "@/src/svg/sidebar/AgentsSvg";
import ViseSvg from "@/src/svg/sidebar/ViseSvg";
import DatabaseSvg from "@/src/svg/sidebar/DatabaseSvg";
import TeamSvg from "@/src/svg/sidebar/TeamSvg";
import SendingMessagesSvg from "@/src/svg/sidebar/SendingMessagesSvg";
import SupportSvg from "@/src/svg/sidebar/SupportSvg";
import RecognitionSvg from "@/src/svg/sidebar/RecognitionSvg";
import GuidelineSvg from "@/src/svg/sidebar/GuidelineSvg";

export const sideBarMenuAllOptions = {
  main: [
    {
      id: "home",
      text: "Home",
      link: "/",
    },
    {
      id: "my-tasks",
      text: "My tasks",
      link: "/tasks",
    },
    {
      id: "online-applications",
      text: "Online applications",
      link: "/applications",
    },
    {
      id: "admissions-office",
      text: "Admissions office",
      link: "/admissions-office/malta/admission",
    },
    {
      id: "agents",
      text: "Agents",
      link: "#",
    },
    {
      id: "visa-process",
      text: "Visa process",
      link: "#",
    },
  ],
  tools: [
    {
      id: "database",
      text: "Database",
      link: "#",
    },
    {
      id: "my-team",
      text: "My team",
      link: "#",
    },
    {
      id: "sending-massages",
      text: "Sending massages",
      link: "#",
    },
    {
      id: "support",
      text: "Support",
      link: "#",
    },
    {
      id: "recognition",
      text: "Recognition",
      link: "#",
    },
    {
      id: "guideline",
      text: "Guideline",
      link: "#",
    },
    {
      id: "admissions-office-database",
      text: "Admissions Database",
      link: "/admissions-office-database",
    },
    {
      id: "office-accounting",
      text: "Office Accounting",
      link: "/office-accounting",
    },
  ],
  adminPanel: [
    {
      id: "user",
      text: "User",
      link: "/user",
    },
  ],
};
export const sideBarMenuFilters = {
  main: [
    {
      id: "home",
      text: "Home",
      link: "/",
    },
    {
      id: "my-tasks",
      text: "My tasks",
      link: "/tasks",
    },
    {
      id: "online-applications",
      text: "Online applications",
      link: "/applications",
    },
    {
      id: "admissions-office",
      text: "Admissions office",
      link: "/admissions-office",
    },
    {
      id: "agents",
      text: "Agents",
      link: "#",
    },
    {
      id: "visa-process",
      text: "Visa process",
      link: "#",
    },
  ],
  tools: [
    {
      id: "database",
      text: "Database",
      link: "#",
    },
    {
      id: "my-team",
      text: "My team",
      link: "#",
    },
    {
      id: "sending-massages",
      text: "Sending massages",
      link: "#",
    },
    {
      id: "support",
      text: "Support",
      link: "#",
    },
    {
      id: "recognition",
      text: "Recognition",
      link: "#",
    },
    {
      id: "guideline",
      text: "Guideline",
      link: "#",
    },
    {
      id: "admissions-office-database",
      text: "Admissions Database",
      link: "/admissions-office-database",
    },
    {
      id: "office-accounting",
      text: "Office Accounting",
      link: "/office-accounting",
    },
  ],
  adminPanel: [
    {
      id: "user",
      text: "User",
      link: "/user",
    },
  ],
};
export const sideBarMenuSvg = [
  { id: "home", svg: HomeSvg },
  { id: "my-tasks", svg: TaskSvg },
  { id: "online-applications", svg: ApplicationsSvg },
  { id: "admissions-office", svg: AdmissionsSvg },
  { id: "agents", svg: AgentsSvg },
  { id: "visa-process", svg: ViseSvg },
  { id: "database", svg: DatabaseSvg },
  { id: "my-team", svg: TeamSvg },
  { id: "sending-massages", svg: SendingMessagesSvg },
  { id: "support", svg: SupportSvg },
  { id: "recognition", svg: RecognitionSvg },
  { id: "guideline", svg: GuidelineSvg },
  { id: "admissions-office-database", svg: DatabaseSvg },
  { id: "user", svg: GuidelineSvg },
  { id: "office-accounting", svg: GuidelineSvg },
];
